<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'process.ops-modal.title'">
    </span>
  </div>
  <div class="common-modal__content-scroll-column">
    <div class="common-content-button-card__card-container"
      [ngClass]="{'common-content-button-card__card-container--separator': processOpsModal.processTitle}">
      <div class="common-content-button-card__card-header-block">
        <div class="common-content-button-card__header-text-container">
          <div class="common-content-button-card__header-inner-text-container">
            <i class="lf-icon-process common-icon__md common-icon__main"></i>
            <p class="common-content-button-card__header-text-title"
              [afTranslate]="'process.ops-modal.process-title'">_Proceso del concepto</p>
              @if((processOpsModal.concept.isFront && !processOpsModal.concept.processId) || !processOpsModal.hasBackProcess){
                <div class="common-tag__mandatory-obligatory-message common-tag__mandatory-obligatory-message--center">
                  <span class="common-tag__mandatory-text-asterisk">
                    *
                  </span>
                  <span class="common-tag__mandatory-label-text-obligatory"
                    [afTranslate]="'common.required-with-bracket'"></span>
                </div>
              }
          </div>
        </div>
        <button class="common-button__icon-lg"
          (click)="createOrEditProcess()">
          <i [class]="processOpsModal.processButtonIcon + ' common-icon__md'"></i>
        </button>
      </div>
      @if(processOpsModal.processId){
        <div class="common-content-button-card__configurated-fields-block">
          <div class="common-tag__neutral-light">
            <span class="common-tag__neutral-label-text">{{processOpsModal.processTitle}}</span>
          </div>
        </div>
      }@else {
        <div class="process-ops-modal__empty-process-container">
          <p class="process-ops-modal__empty-process-text">
            {{processOpsModal.processTitle}}
          </p>
        </div>
      }
    </div>
    <div class="common-content-button-card__card-container"
      [ngClass]="{'common-content-button-card__card-container--separator': processOpsModal.task,
        'common-content-button-card__card-container--disabled': !processOpsModal.processId}">
      <div class="common-content-button-card__card-header-block">
        <div class="common-content-button-card__header-text-container">
          <div class="common-content-button-card__header-inner-text-container">
             <i class="lf-icon-task common-icon__md common-icon__main" [ngClass]="{'common-icon__disabled':!processOpsModal.processId}"></i>
            <p class="common-content-button-card__header-text-title"
              [ngClass]="{'common-content-button-card__header-text-title--disabled':!processOpsModal.processId}"
              [afTranslate]="'process.ops-modal.task-table-title'">Tarea de proceso</p>
              @if(!(processOpsModal.task && processOpsModal.hasBackProcess)){
                <div class="common-tag__mandatory-obligatory-message common-tag__mandatory-obligatory-message--center">
                  <span class="common-tag__mandatory-text-asterisk"
                    [ngClass]="{'common-tag__mandatory-text-asterisk--disabled': !processOpsModal.processId}">
                    *
                  </span>
                  <span class="common-tag__mandatory-label-text-obligatory"
                    [afTranslate]="'common.required-with-bracket'"></span>
                </div>
              }
          </div>
        </div>
        <button class="common-button__icon-lg"
          [ngClass]="{'common-button__icon-lg--disabled': !processOpsModal.processId || processOpsModal.task}"
          [disabled]="!processOpsModal.processId || processOpsModal.task"
          (click)="addTask()">
          <i class="lf-icon-add-round common-icon__md"></i>
        </button>
      </div>
      @if(processOpsModal.task){
        <div class="common-table-instance__body-container">
          <div class="common-table-header__container">
            <div class="common-table-body__inner-row w-[calc(100%-30px)]">
              <div class="common-table-cell__container w-[25%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('process.ops-modal.title-column' | afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[25%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('process.ops-modal.creator-column' | afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[25%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('process.ops-modal.recipient-column' | afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[25%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('common.creation' | afTranslate)">
                </span-tooltip>
              </div>
            </div>
            <div class="common-table-cell__container w-[30px]"></div>
          </div>
          <div class="common-table-body__container">
            <div class="common-table-body__row">
              <div class="common-table-body__inner-row w-[calc(100%-30px)]"
                (click)="editTask()">
                <div class="common-table-cell__container w-[25%]">
                  <span-tooltip class="common-table-cell__standard-text-label"
                    [text]="processOpsModal.task.title">
                  </span-tooltip>
                </div>
                <div class="common-table-cell__container w-[25%]">
                  <span-tooltip class="common-table-cell__standard-text-label"
                    [text]="(processOpsModal.task.creator?.fullName + (processOpsModal.task.creator?.isDeleted ? ' ('+ ('common.inactive-user' | afTranslate)+')' : ''))">
                  </span-tooltip>
                </div>
                <div class="common-table-cell__container w-[25%]">
                  @if (processOpsModal.task.responsiblesList?.length) {
                    <participants-list
                      [participants]="processOpsModal.task.responsiblesList"
                      [notificated]="false"
                      [type]="'task-process'">
                    </participants-list>
                  }
                </div>
                <div class="common-table-cell__container w-[25%]">
                  <span-tooltip class="common-table-cell__standard-text-label"
                    [text]="processOpsModal.task.creationDate | convertDate:'without-time'">
                  </span-tooltip>
                </div>
              </div>
              <div class="common-table-cell__container-actions w-[30px]">
                <button class="common-button__icon-md-noborder"
                  (click)="deleteTask($event)"
                  pTooltip="{{'common.remove' | afTranslate}}"
                  tooltipPosition="bottom">
                  <i class="lf-icon-trash common-icon__md"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="common-content-button-card__card-container"
      [ngClass]="{'common-content-button-card__card-container--separator': processOpsModal.task,
        'common-content-button-card__card-container--disabled': !processOpsModal.processId}">
      <div class="common-content-button-card__card-header-block">
        <div class="common-content-button-card__header-text-container">
          <div class="common-content-button-card__header-inner-text-container">
            <i class="lf-icon-notification common-icon__md common-icon__main" [ngClass]="{'common-icon__disabled':!processOpsModal.processId}"></i>
            <p class="common-content-button-card__header-text-title"
              [ngClass]="{'common-content-button-card__header-text-title--disabled':!processOpsModal.processId}"
              [afTranslate]="'process.ops-modal.alerts-table-title'">
              Alertas generales de proceso
            </p>
          </div>
        </div>
        <button class="common-button__icon-lg"
          [ngClass]="{'common-button__icon-lg--disabled': !processOpsModal.processId}"
          [disabled]="!processOpsModal.processId"
          (click)="addAlert()">
          <i class="lf-icon-add-round common-icon__md"></i>
        </button>
      </div>
      @if (processOpsModal.alerts && processOpsModal.alerts.length) {
        <div class="common-table-instance__body-container">
          <div class="common-table-header__container">
            <div class="common-table-body__inner-row w-[calc(100%-30px)]">
              <div class="common-table-cell__container w-[20%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('process.ops-modal.title-column' | afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[20%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('common.state' | afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[20%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('process.ops-modal.creator-column' | afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[20%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('process.ops-modal.recipient-column' | afTranslate)">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[20%]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="('process.ops-modal.alert-date-column' | afTranslate)">
                </span-tooltip>
              </div>
            </div>
            <div class="common-table-cell__container w-[30px]"></div>
          </div>
          <div class="common-table-body__container max-h-[237px]">
            @for (alert of processOpsModal.alerts; track $index) {
              <div class="common-table-body__row">
                <div class="common-table-body__inner-row w-[calc(100%-30px)]"
                  (click)="editAlert(alert)">
                  <div class="common-table-cell__container w-[20%]">
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="alert.title">
                    </span-tooltip>
                  </div>
                  <div class="common-table-cell__container w-[20%]">
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="alert.stateName">
                    </span-tooltip>
                  </div>
                  <div class="common-table-cell__container w-[20%]">
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="(alert.creator.fullName + (alert.creator.isDeleted ? ' (' + ('common.inactive-user' | afTranslate) + ')' : ''))">
                    </span-tooltip>
                  </div>
                  <div class="common-table-cell__container w-[20%]">
                    @if (alert.destination.length) {
                      <participants-list
                        [participants]="alert.destination"
                        [notificated]="alert.notifyToIdentifying"
                        [type]="'alert'">
                      </participants-list>
                    }
                  </div>
                  <div class="common-table-cell__container w-[20%]">
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="alert.date">
                    </span-tooltip>
                  </div>
                  <div class="common-table-cell__container-actions w-[30px]">
                    @if (processOpsModal.userPermissions === 'all') {
                      <button class="common-button__icon-md-noborder"
                        (click)="deleteAlert($event, alert)"
                        pTooltip="{{'common.remove' | afTranslate}}"
                        tooltipPosition="bottom">
                        <i class="lf-icon-trash common-icon__md"></i>
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    @if (skin === 'icam-red' && processOpsModal.concept.allowPublicShare) {
      <div class="common-content-button-card__card-container"
        [ngClass]="{'common-content-button-card__card-container--separator': processOpsModal.task,
          'common-content-button-card__card-container--disabled': !processOpsModal.processId}">
        <div class="common-content-button-card__card-header-block">
          <div class="common-content-button-card__header-text-container">
            <div class="common-content-button-card__header-inner-text-container">
              <i class="lf-icon-transparency-report common-icon__md common-icon__main"></i>
              <p class="common-content-button-card__header-text-title"
                [ngClass]="{'common-content-button-card__header-text-title--disabled':!processOpsModal.processId}"
                [afTranslate]="'process.ops-modal.automatic-post-process'">
                Publicaciones automáticas en función del proceso
              </p>
            </div>
          </div>
          <button class="common-button__icon-lg"
            [ngClass]="{'common-button__icon-lg--disabled': !processOpsModal.processId}"
            [disabled]="!processOpsModal.processId || processOpsModal.userPermissions !== 'all'"
            (click)="addOrEditAutomaticProcess()">
            <i class="lf-icon-add-round common-icon__md"></i>
          </button>
        </div>
        @if (processOpsModal.automaticProcess && processOpsModal.automaticProcess.length) {
          <div class="common-table-instance__body-container">
            <div class="common-table-header__container">
              <div class="common-table-body__inner-row w-[calc(100%-30px)]">
                <div class="common-table-cell__container w-[34%]">
                  <span-tooltip class="common-table-cell__title-text-label"
                    [text]="('common.state' | afTranslate)">
                  </span-tooltip>
                </div>
                <div class="common-table-cell__container w-[33%]">
                  <span-tooltip class="common-table-cell__title-text-label"
                    [text]="('process.ops-modal.creator-column' | afTranslate)">
                  </span-tooltip>
                </div>
                <div class="common-table-cell__container w-[33%]">
                  <span-tooltip class="common-table-cell__title-text-label"
                    [text]="('process.ops-modal.publication-date' | afTranslate)">
                  </span-tooltip>
                </div>
              </div>
              <div class="common-table-cell__container w-[30px]"></div>
            </div>
            <div class="common-table-body__container">
              @for (process of processOpsModal.automaticProcess; track $index) {
                <div class="common-table-body__row">
                  <div class="common-table-body__inner-row w-[calc(100%-30px)]"
                    (click)="addOrEditAutomaticProcess(process)">
                    <div class="common-table-cell__container w-[34%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="process.stateName">
                      </span-tooltip>
                    </div>
                    <div class="common-table-cell__container w-[33%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="(process.creator.fullName + (process.creator.isDeleted ? ' (' + ('common.inactive-user' | afTranslate) + ')' : ''))">
                      </span-tooltip>
                    </div>
                    <div class="common-table-cell__container w-[33%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="process.date">
                      </span-tooltip>
                    </div>
                  </div>
                  <div class="common-table-cell__container w-[30px]">
                    <button class="common-button__icon-md-noborder"
                      (click)="deleteAutomaticProcess(process)"
                      pTooltip="{{'common.remove' | afTranslate}}"
                      tooltipPosition="bottom">
                      <i class="lf-icon-trash common-icon__md"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (processOpsModal.concept.allowPublicShare && !processOpsModal.concept.lockedEdit) {
      <div class="common-content-button-card__card-container"
        [ngClass]="{'common-content-button-card__card-container--separator': processOpsModal.processBlockedList.length,
          'common-content-button-card__card-container--disabled': !processOpsModal.processId}">
        <div class="common-content-button-card__card-header-block">
          <div class="common-content-button-card__header-text-container">
            <div class="common-content-button-card__header-inner-text-container">
              <i class="lf-icon-not-editable common-icon__md common-icon__main" [ngClass]="processOpsModal.concept.lockedEdit?'common-icon__main': 'common-icon__disabled'"></i>
              <!-- <i class="lf-icon-not-editable common-icon__md common-icon__main"></i> -->
              <p class="common-content-button-card__header-text-title"
                [ngClass]="{'common-content-button-card__header-text-title--disabled':!processOpsModal.processId}"
                [afTranslate]="'process.ops-modal.blocked-edition'">
                Edición bloqueada en función del proceso
              </p>
            </div>
          </div>
          <button class="common-button__icon-lg"
            [ngClass]="{'common-button__icon-lg--disabled': !processOpsModal.processId}"
            [disabled]="!processOpsModal.processId"
            (click)="configureBlockedEdition()">
            <i class="common-icon__md "
              [ngClass]="processOpsModal.processBlockedList.length?'lf-icon-editable-form':'lf-icon-add-round'"></i>
          </button>
        </div>
        @if(processOpsModal.processBlockedList.length){
          <div class="common-content-button-card__card-info-block">
            <p class="common-table-cell__nobold-total-text-label"
            [afTranslate]="'process.ops-modal.blocked-edition-header-info'">No se permitirá modificar los datos del solicitante en los siguientes estados:>
            </p>
            <div>
              @for (processBlocked of processOpsModal.processBlockedList; track $index) {
                <div class="common-button__container-typetext-checkbox">
                  <div  class="common-button__block-typetext-checkbox">
                    <div class="common-button__block-button-md-checkbox">
                      <button class="common-button__icon-md-checkbox common-button__icon-md-checkbox--disabled common-button__icon-md-checkbox--selected">
                        <i class="common-icon__md lf-icon-check-full"></i>
                      </button>
                    </div>
                    <div class="common-button__block-text-checkbox">
                      <span class="common-button__text-checkbox common-button__text-checkbox--disabled">
                        {{processBlocked.stateName}}
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
  }
  </div>
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleAccept()">
      <span class="common-button__text-title"
        [afTranslate]="'common.finish'">
      </span>
    </button>
  </div>
</div>
